<template>
    <div class="fixed z-50 bottom-0 left-0 w-full shadow-rev">
        <slot />
        <div class="relative z-50 bg-white p-4 flex justify-between desktop:justify-end -mx-1 desktop:mx-0">
            <div class="chat-wrapper chat-footer flex mr-auto">
                <div
                    v-if="showPhoneNumber"
                    class="hidden desktop:inline-flex text-base flex flex-col justify-center">
                    <span class="inline-block align-middle">
                        <IconPhone />
                        <a :href="`tel:${phoneNumber}`">
                            {{ phoneNumber }}
                        </a>
                    </span>
                </div>
                <button
                    v-else
                    @click.prevent="showPhoneNumber = true"
                    class="hidden desktop:block buyflow-button-alt h-14 w-14"
                    aria-label="Phone">
                    <IconPhone class="text-xl" />
                </button>

                <div class="ccai-launcher buyflow-button-alt buyflow-custom-chat-button p-0 flex items-center justify-center">
                    <data id="ccaiRegion" :value="ccaiRegion()"></data>
                    <svg class="ccai-open buyflow-chat-footer-icon" viewBox="0 0 100 100" focusable="false" role="image" aria-hidden="true">
                        <path d="M25,54.1677083 L75,54.1677083 L75,50.0005208 L25,50.0005208 L25,54.1677083 Z M25,37.5005208 L75,37.5005208 L75,33.3333333 L25,33.3333333 L25,37.5005208 Z M42.03125,95.8333333 L37.5,95.8333333 L37.5,91.6661458 L42.03125,91.6661458 C48.721875,91.6661458 54.7375,87.9489583 57.7296875,81.9645833 L60.6359375,76.1520833 C60.9890625,75.4458333 61.7109375,75.0005208 62.5,75.0005208 L64.5828125,75.0005208 C81.8140625,75.0005208 95.8328125,60.9817708 95.8328125,43.7505208 C95.8328125,26.5192708 81.8140625,12.5005208 64.5828125,12.5005208 L35.415625,12.5005208 C18.184375,12.5005208 4.165625,26.5192708 4.165625,43.7505208 C4.165625,60.9817708 18.184375,75.0005208 35.415625,75.0005208 L37.5,75.0005208 L37.5,79.1661458 L35.415625,79.1661458 C15.8875,79.1661458 0,63.2786458 0,43.7505208 C0,24.2208333 15.8875,8.33333333 35.415625,8.33333333 L64.5828125,8.33333333 C84.1109375,8.33333333 100,24.2208333 100,43.7505208 C100,63.2786458 84.1109375,79.1661458 64.5828125,79.1661458 L63.7875,79.1661458 L61.45625,83.8286458 C57.753125,91.2333333 50.3109375,95.8333333 42.03125,95.8333333 L42.03125,95.8333333 Z"></path>
                    </svg>
                    <svg class="ccai-close" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                        <path d="M106.097 154.501a8.63 8.63 0 0 1-12.082 0L2.696 64.99a8.632 8.632 0 0 1-.086-12.24l7.068-7.113a8.63 8.63 0 0 1 12.143-.095l72.211 70.35a8.63 8.63 0 0 0 12.048 0l72.21-70.358a8.63 8.63 0 0 1 12.144.095l7.06 7.112a8.632 8.632 0 0 1-.087 12.249l-91.31 89.511z"></path>
                    </svg>

                    <svg class="ccai-loader" style="opacity: 0;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg>
                </div>
            </div>

            <button
                v-if="skipText && nextIndex === -1"
                @click.prevent="handleSkipClick({ name: skipRouteName })"
                class="buyflow-button-nav mx-1 desktop:mx-0 flex items-center flex-grow desktop:flex-grow-0 justify-center">
                <span :class="skipShortText ? 'hidden desktop:inline' : null">
                    {{ skipText }}
                </span>
                <span class="desktop:hidden">
                    {{ skipShortText }}
                </span>
                <IconAngleDoubleRight class="ml-1"/>
            </button>

            <button
                @click.prevent="handleCompleteOrder()"
                class="buyflow-button-nav text-white bg-blue hover:bg-blue-light hover:border-transparent mx-1 desktop:mx-0 desktop:ml-4 flex items-center  flex-grow desktop:flex-grow-0 justify-center"
                data-cy="btn-advance"
                :disabled="!nextIsAllowed">
                <span :class="nextShortText ? 'hidden desktop:inline' : null">
                    {{ checkHasSelectedAService }}
                </span>
                <span class="desktop:hidden">
                    {{ (nextIndex === -1? nextShortText: nextHiddenText[nextIndex]) }}
                </span>
                <IconArrowRight class="ml-1"/>
            </button>
        </div>
    </div>
</template>

<script>
import Chat from '@/molecules/Chat'
import IconAngleDoubleRight from "@/atoms/icons/IconAngleDoubleRight"
import IconArrowRight from "@/atoms/icons/IconArrowRight"
import IconPhone from "@/atoms/icons/IconPhone"
import { mapGetters, mapState } from 'vuex'
export default {
    name: 'AppPageNav',
        components: {
            Chat,
            IconAngleDoubleRight,
            IconArrowRight,
            IconPhone,
        },
        props: {
            nextText: {
                type: String,
                required: true,
            },
            nextShortText: {
                type: String,
                default: null,
            },
            nextRouteName: {
                type: String,
                required: true,
            },
            nextIsAllowed: {
                type: Boolean,
                default: true,
            },
            phoneNumber: {
                type: String,
                default: null
            },
            skipText: {
                type: String,
                default: null,
            },
            skipShortText: {
                type: String,
                default: null,
            },
            skipRouteName: {
                type: String,
                default: null,
            },
            nextTypes: {
                type: Array,
                default: () => [],
            },
            nextHiddenText: {
                type: Array,
                default: () => [],
            },
            nextHiddenRouteName: {
                type: Array,
                default: () => [],
            },
            sectionStatus:{
                type: Function,
                required: true,
            }
        },
        data: () => ({
            showPhoneNumber: false,
        }),

        mounted() {
            import('^/ccaiWidget.js');
        },
        computed:{
            ...mapGetters('Buyflow/tv', [
                'hasSelectedAService',
            ]),
            ...mapState([
                'meta'
            ]),
            checkHasSelectedAService() {
                const hasSelectedAService = this.hasSelectedAService;
                const nextText = this.nextText;
                if (!hasSelectedAService && nextText === 'Next: Customize Voice') {
                    return 'Next: Customize Voice'
                } else {
                    if (this.nextIndex === -1) {
                        return nextText;
                    } else {
                        return this.nextHiddenText[this.nextIndex];
                    }
                }
            },
            nextIndex(){
                let statusIndex = 0
                for (let i in this.nextTypes) {
                    const status = this.sectionStatus('buyflow_hide', this.nextTypes[i])
                    if (status) {
                        statusIndex++
                    } else if (i === 0){
                        return -1
                    }
                }
                if (statusIndex) {
                    return statusIndex - 1
                }
                return -1
            },
        },
        methods: {
            ccaiRegion() {
                return this.meta.stateOrProvince
            },
            handleSkipClick(routeInfo) {
                this.pushEvent('skip_to_checkout', {
                    'flow_step_name': this.$route.name === 'buyflow-internet' ? 'choose internet and wifi options' :
                                    this.$route.name === 'buyflow-tv' ? 'customize tv' :
                                    this.$route.name === 'buyflow-voice' ? 'customize home phone' : '',
                    'flow_step_number': this.$route.name === 'buyflow-internet' ? '1' :
                                    this.$route.name === 'buyflow-tv' ? '2' :
                                    this.$route.name === 'buyflow-voice' ? '3' : ''
                });
                
                // Emit the skip event to continue with navigation
                this.$emit('skip', routeInfo);
            },
            handleCompleteOrder() {
                if (this.$route.name === 'buyflow-installation') {
                    // Get cartData
                    const cartData = this.$store.state.Buyflow.receipt.cartData;
                    console.log('cartnow: ', cartData) //debug
                    this.pushEvent('add_shipping_info', {
                        'event_label': 'checkout_complete_my_order',
                        'flow_step_name': 'final step',
                        'flow_step_number': '4',
                        'items': this.getCartItems(cartData), // get cart items
                        'currency': 'USD',
                        'value': cartData?.firstMonthTotal || 0
                    });
                }
                
                // Continue with navigation if allowed
                if (this.nextIsAllowed) {
                    this.$emit('next', { 
                        name: (this.nextIndex === -1 ? this.nextRouteName : this.nextHiddenRouteName[this.nextIndex]) 
                    });
                }
            },

            // Add the getCartItems method to this component
            getCartItems(cartData) {
                const items = [];
                if (!cartData) {
                    return [];
                }
                
                // Add Internet service
                if (cartData.services?.internet?.length) {
                    cartData.services.internet.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'internet',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: 1
                        });
                    });
                }
                
                // Add Internet equipment
                if (cartData.addOns?.internet?.equipment?.length) {
                    cartData.addOns.internet.equipment.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'internet-equipment',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: item.quantity
                        });
                    });
                }
                
                // Add TV service
                if (cartData.services?.tv?.length) {
                    cartData.services.tv.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'tv',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: 1
                        });
                    });
                }
                
                // Add TV packages
                if (cartData.addOns?.tv?.packages?.length) {
                    cartData.addOns.tv.packages.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'tv-package',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: item.quantity
                        });
                    });
                }
                
                // Add TV base options
                if (cartData.addOns?.tv?.base?.length) {
                    cartData.addOns.tv.base.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'tv-base',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: item.quantity
                        });
                    });
                }
                
                // Add TV equipment
                if (cartData.addOns?.tv?.equipment?.length) {
                    cartData.addOns.tv.equipment.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'tv-equipment',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: item.quantity
                        });
                    });
                }
                
                // Add Voice service
                if (cartData.services?.voice?.length) {
                    cartData.services.voice.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'voice',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: 1
                        });
                    });
                }
                
                // Add Voice options
                if (cartData.addOns?.voice?.base?.length) {
                    cartData.addOns.voice.base.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'voice-base',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: item.quantity
                        });
                    });
                }
                
                // Add Installation
                if (cartData.addOns?.installation?.base?.length) {
                    cartData.addOns.installation.base.forEach(item => {
                        items.push({
                            item_id: item.name,
                            item_name: item.name,
                            item_category: 'installation',
                            item_brand: 'Breezeline Online',
                            price: item.promoPrice,
                            quantity: item.quantity
                        });
                    });
                }
            
                return items;
            }
        }
    }
</script>

<style scoped>
    .icon-height {
        height: 60px;
    }
</style>
